/** Dueli: радиусы больше, чем в default */
export const primitiveRadius = {
	sm: '10px',
	md: '14px',
	lg: '20px',
	xl: '28px',
	full: '9999px',
} as const;

export const radius = {
	large: primitiveRadius.lg,
	normal: primitiveRadius.sm,
} as const;
